// byte 파일 크기를 megabyte 포맷으로 변경해줍니다.
export const formatMegaByte = (byte: number) => {
  return (byte / 1024 / 1024).toFixed(2);
};
